import { createSelector } from '@ngrx/store';

import { HotelResultsState } from '@hotels/hotel-results/store/reducers/hotel-results.reducer';
import { HotelResultsModuleState } from '@hotels/hotel-results/store/state/hotel-results-module.state';
import { mapHotelMarkers, mapHotelSearchData } from '@hotels/hotel-results/mappers/hotel-results.mapper';
import { hotelResultsRootSelector } from '@hotels/hotel-results/store/selectors/hotel-results-root.selector';
import { HotelSearched } from '@hotels/hotel-results/entities/hotel-searched';

export const getHotelResultsState = createSelector(
  hotelResultsRootSelector,
  (state: HotelResultsModuleState) => state?.hotelResults
);

export const hotelResults = createSelector(getHotelResultsState, (state: HotelResultsState) => state?.Results);
export const hotelResultsExclusiveOffer =
  createSelector(getHotelResultsState, (state: HotelResultsState) => state?.ResultsExclusiveOffer);
export const hotelMarkers = createSelector(getHotelResultsState, (state: HotelResultsState) => state?.ResultsMarkers);
export const searchedHotel = createSelector(getHotelResultsState, (state: HotelResultsState) => state?.SearchedHotel);
export const hotelSearchData = createSelector(getHotelResultsState, (state: HotelResultsState) => mapHotelSearchData(state));
export const hotelResultsWithMarkers =
  createSelector(hotelMarkers, (state: HotelSearched[]) => mapHotelMarkers(state));
